export default __webpack_public_path__ + "static/media/newsletter6.3b66d13a.jpeg";